import type {CharacterAppearance} from './characterAppearance';

let worker:Worker|undefined;let sequence=0;
let initializing:Promise<void>|undefined;
const pending=new Map<number,{resolve:(bitmap:ImageBitmap)=>void;reject:(error:Error)=>void;timer:number}>();
/** A single lazy worker serves both editor previews and city sprites. */
export async function characterImage(appearance:CharacterAppearance,preview=false,row=1,onlyPart?:string):Promise<ImageBitmap>{
 if(!worker){
  initializing??=import('./characterWorker?worker').then(({default:CharacterWorker})=>{
  worker=new CharacterWorker();
  worker.onmessage=event=>{
   const {id,bitmap,error}=event.data;const job=pending.get(id);
   if(!job){bitmap?.close();return;}
   pending.delete(id);window.clearTimeout(job.timer);
   if(error)job.reject(new Error(error));else job.resolve(bitmap);
  };
  worker.onerror=()=>{
   for(const job of pending.values()){window.clearTimeout(job.timer);job.reject(new Error('ساخت تصویر کاراکتر انجام نشد.'));}
   pending.clear();worker?.terminate();worker=undefined;initializing=undefined;
  };
  }).catch(error=>{initializing=undefined;throw error;});
  await initializing;
 }
 const id=++sequence;
 return new Promise((resolve,reject)=>{
  const timer=window.setTimeout(()=>{pending.delete(id);reject(new Error('بارگیری کاراکتر طول کشید؛ دوباره تلاش کنید.'));},120000);
  pending.set(id,{resolve,reject,timer});worker!.postMessage({id,appearance,preview,row,onlyPart});
 });
}
